import { useEffect, useReducer } from "react";
import {
  userManagementInitialState,
  userManagementReducer,
} from "./userManagement.reduse";
import { getTeamHierarchyDetais } from "../api/teamHierarchy.api";
import { useAuth } from "../../../../contexts/AuthContext";

export const useUserManagementViewModel = () => {
  const [state, dispatch] = useReducer(
    userManagementReducer,
    userManagementInitialState,
  );
  const { user } = useAuth();
  useEffect(() => {
    if (user?.company_id) {
      loadTeamHierarchyDetails();
    }
  }, [user?.company_id]);
  const loadTeamHierarchyDetails = async () => {
    try {
      const response = await getTeamHierarchyDetais(user?.company_id || "");
      dispatch({ type: "SET_TEAM_HIERARCHY", payload: response.data });
      console.log(response.data);
    } catch (error) {
      console.error("Error fetching team hierarchy details:", error);
    }
  };
  return {
    state,
    dispatch,
  };
};
